<template>
  <div>
    <div class="max-width" style="margin-top: 3.125vw">
      <enter-btn style="margin-bottom: 60px" />
      <policy-month style="margin-bottom: 100px" />
      <!-- <div style="text-align: center; padding-top: 40px">
        <img width="280px" src="@/assets/images/page_none_default.png" alt="" />
        <div style="color: #333; font-size: 18px">政策更新中</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import EnterBtn from './components/EnterBtn'
import PolicyMonth from './components/PolicyMonth'
export default {
  name: 'PolicyInquiries',
  components: { EnterBtn, PolicyMonth },
  data() {
    return {
      dataForm: {},
      hotSearchList: [
        { link: 'javascript:;', text: '生活安居类' },
        { link: 'javascript:;', text: '培养升级类' },
        { link: 'javascript:;', text: '引才支持类' },
      ],
    }
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
